// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sceptile: PokeData = {
  "id": 254,
  "name": "sceptile",
  "height": 17,
  "weight": 522,
  "base_experience": 239,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "pound",
    "slam",
    "leer",
    "absorb",
    "mega-drain",
    "agility",
    "quick-attack",
    "screech",
    "double-team",
    "detect",
    "giga-drain",
    "false-swipe",
    "fury-cutter",
    "pursuit",
    "endeavor",
    "leaf-blade",
    "assurance",
    "night-slash",
    "x-scissor",
    "energy-ball",
    "leaf-storm",
    "quick-guard",
    "dual-chop",
    "leafage"
  ],
  "moves": [
    "leer",
    "quick-attack",
    "pursuit",
    "night-slash",
    "energy-ball",
    "power-whip",
    "wood-hammer",
    "razor-leaf",
    "solar-beam",
    "synthesis",
    "aromatherapy",
    "frenzy-plant",
    "overgrowth"
  ],
  "evolution_chain": {
    "id": 130,
    "item": null,
    "species": [
      {
        "name": "treecko",
        "order": 277,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grovyle",
        "order": 278,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 252,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "sceptile",
        "order": 279,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 253,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 161,
    "ability_power": 141
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
